module.exports = __webpack_public_path__ + "img/52.1.a3f2898d.jpg";